import {gql} from '@apollo/client';

export const CHECKOUT_ABANDONMENT_SUMMARY = gql`
  query CheckoutAbandonmentSummary($input: CheckoutAbandonmentFilter!) {
    adminCheckoutAbandonmentSummary(input: $input) {
      __typename
      ... on ResponseWithCheckoutAbandonmentSummary {
        data {
          total
          counts {
            flow
            reason
            count
          }
        }
      }
      ... on Error {
        message
        statusCode
      }
    }
  }
`;

export const CHECKOUT_ABANDONMENTS = gql`
  query CheckoutAbandonments($input: CheckoutAbandonmentFilter!) {
    adminCheckoutAbandonments(input: $input) {
      __typename
      ... on ResponseWithCheckoutAbandonments {
        data {
          id
          clientEventId
          createdAt
          flow
          reason
          otherReasonText
          step
          currency
          amount
          paymentMethod
          subscriptionPlan
          billingCycle
          platform
          appVersion
          userId
          user {
            id
            firstName
            lastName
            email
            country
          }
        }
        pagination {
          page
          limit
          pages
          total
          hasNextPage
          hasPrevPage
        }
      }
      ... on Error {
        message
        statusCode
      }
    }
  }
`;

export const EXPORT_CHECKOUT_ABANDONMENTS = gql`
  mutation ExportCheckoutAbandonments($input: CheckoutAbandonmentFilter!) {
    exportCheckoutAbandonments(input: $input) {
      __typename
      ... on ResponseWithCheckoutAbandonmentExport {
        message
        data {
          recipient
        }
      }
      ... on Error {
        message
        statusCode
      }
    }
  }
`;
